<div class="dialog">
    <div class="dialog-header centered">
        <img class="icon-big" src="/assets/img/icon-csv.svg" alt="Store icon">

        <h2>{{ data.title | translate }}</h2>
    </div>

    <app-loading *ngIf="uploading"></app-loading>

    <div class="dialog-body" *ngIf="!uploading && csvErrors.length > 0">
        <div class="alert alert-error">
            {{ 'segments.dialog.import.errors' | translate : { errors : csvErrors.length } }}
        </div>

        <ul class="csv-errors">
            <li *ngFor="let line of csvErrors">
                <strong>Line {{ line.line }}</strong>: {{ line.content }}
            </li>
        </ul>

        <div class="buttons">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.close' | translate }}</a>
            <a class="button button-primary" (click)="onStartAgain()">{{ 'shared.button.start-again' | translate }}</a>
        </div>
    </div>

    <div class="dialog-body" *ngIf="!uploading && csvErrors.length === 0">
        <p [innerHTML]="data.message | translate | newlines"></p>

        <div class="csv-template">
            <div class="csv-template-header">
                <span>{{ 'segments.dialog.import.template.heading' | translate }}</span>
                <a class="link" (click)="onDownloadTemplateClick()">{{ 'segments.dialog.import.template.download' | translate }}</a>
            </div>
            <pre class="csv-template-body"><strong>consumer_id;slug</strong>          <em># {{ 'segments.dialog.import.template.comment' | translate }}</em>
<span *ngFor="let row of templateExamples">{{ row[0] }};{{ row[1] }}
</span></pre>
        </div>

        <div class="uploader-container">
            <div class="uploader">
                <app-uploader
                    [label]="'shared.label.select-file' | translate"
                    [types]="[ 'text/csv', 'application/vnd.ms-excel' ]"
                    [autoUpload]="false"
                    [readMode]="'readAsText'"
                    (fileSelected)="onCsvFileSelected($event)"
                    (fileUploaded)="onCsvFileUploaded($event) ">
                         <ng-template appUploaderLoading let-message="message">
                            <app-loading [message]="message"></app-loading>
                        </ng-template>
                </app-uploader>
                <app-form-errors [errors]="selectedFile.errors"></app-form-errors>
            </div>
        </div>

        <div class="buttons">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>
